import { CheckIcon } from '@blueprinthq/joy'
import { Box, Flex, HStack, StackDivider, Text, VStack } from '@chakra-ui/react'
import { DateTime } from 'luxon'
import React from 'react'
import type { PatientIntakeConsentResultsDtoPoliciesItem } from '~/clinician-api/models'

import { PDFIcon } from '../../../icons'

interface ConsentedPolicyItemProps {
  consentItem: PatientIntakeConsentResultsDtoPoliciesItem
}

// Utility function to convert bytes to MB
const convertBytesToMB = (bytes: number): string => {
  const mb = bytes / (1024 * 1024)
  return mb.toFixed(2) + ' MB'
}

export const ConsentedPolicyItem: React.FC<ConsentedPolicyItemProps> = ({
  consentItem
}) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" w="100%" p="12px">
      <HStack spacing="small">
        <Box
          p="12px"
          bg="rgba(87, 89, 91, 0.04)"
          borderRadius="8px"
          alignSelf="flex-start"
        >
          <PDFIcon />
        </Box>
        <VStack alignItems="flex-start">
          <Box>
            <Text fontWeight="bold">
              {consentItem.documentReference.description ||
                consentItem.documentReference.fileName}
            </Text>
          </Box>
          <Box>
            <HStack
              divider={
                <StackDivider
                  borderRight="1px solid"
                  borderRightColor="pale_gray"
                />
              }
            >
              <HStack spacing="4px">
                <CheckIcon fill="#0D8443" size="sm" />
                <Text color="#0D8443" fontSize="xsm">
                  Accepted{' '}
                  {consentItem.dateConsented
                    ? DateTime.fromISO(
                        consentItem.dateConsented as string
                      ).toFormat('yyyy-MM-dd')
                    : ''}
                </Text>
              </HStack>
              <Text fontSize="xsm">
                {consentItem.documentReference.fileName}
              </Text>
              <HStack>
                <Text fontSize="xsm">
                  {convertBytesToMB(consentItem.documentReference.bytes)}
                </Text>
                <Text fontSize="xsm">
                  v{' '}
                  {DateTime.fromISO(
                    consentItem.documentReference.createdAt
                  ).toFormat('yyyy-MM-dd')}
                </Text>
              </HStack>
            </HStack>
          </Box>
        </VStack>
      </HStack>
    </Flex>
  )
}
